import { useEffect, useState } from "react";
import brandLogo from "../../Assets/Images/Logo-white.svg";
import { translatePage } from "../../i18n";
import "../../app.scss";

function Updating() {
    const [language, setLanguage] = useState(() => localStorage.getItem("e-sayar-language") || "az");

    useEffect(() => {
        localStorage.setItem("e-sayar-language", language);
        translatePage(document.querySelector(".updating-page"), language);
    }, [language]);

    return (
        <main className="updating-page">
            <div className="updating-grid" aria-hidden="true" />
            <a className="updating-logo" href="/" aria-label="E-sayar ana səhifə">
                <img src={brandLogo} alt="E-sayar" />
            </a>
            <label className="language-picker updating-language" aria-label="Dil">
                <select value={language} onChange={event => setLanguage(event.target.value)}>
                    <option value="az">AZ</option>
                    <option value="en">EN</option>
                    <option value="tr">TR</option>
                    <option value="ru">RU</option>
                </select>
            </label>
            <section className="updating-card">
                <div className="updating-icon" aria-hidden="true">
                    <span /><span /><span />
                </div>
                <p className="updating-kicker">E-SAYAR</p>
                <h1>Məhsul yenilənir<span className="updating-dots">...</span></h1>
                <p>E-sayar təcrübəsini daha da yaxşılaşdırırıq.<br/>Məhsul tezliklə yenidən əlçatan olacaq.</p>
                <div className="updating-progress" aria-hidden="true"><span /></div>
                <a href="/">← Sayta qayıt</a>
            </section>
            <small className="updating-footer">© 2026 E-sayar</small>
        </main>
    );
}

export default Updating;
